import { render } from "./CheckboxMulti.vue?vue&type=template&id=502d0e9e"
import script from "./CheckboxMulti.vue?vue&type=script&lang=js"
export * from "./CheckboxMulti.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/wp-content/themes/w2w/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__